<template>
  <div class="customers-page">

    <!-- ===== HEADER ===== -->
    <div class="page-title">
      <h1>Customers</h1>
      <p>Manage, segment, and monitor your customers for review and referral campaigns.</p>
    </div>
    <!-- ===== TOOLBAR ===== -->
    <div class="toolbar">

      <div class="toolbar-left">

        <div class="search-box">
          <span class="material-symbols-outlined">search</span>

          <input v-model="search_key" placeholder="Search customers by name, email, or phone..." />
        </div>
        <!-- Campaign Type Selector -->
        <div class="type-select">
          <select v-model="campaignType" @change="loadCustomers">
            <option value="Review">Review Campaign</option>
            <option value="Ref">Referral Campaign</option>
          </select>
        </div>
        <div class="type-select">
          <select v-if="campaignType" v-model="selectedCampaign" @change="loadCustomers">
            <option value="">Select Campaign</option>
            <option v-for="camp in camps" :key="camp.camp_id" :value="camp.camp_id">
              {{ camp.camp_title }}
            </option>
          </select>
        </div>
        <!-- ===== STAR FILTER ===== -->
        <div class="filter-wrapper" v-if="campaignType==='Review'">

          <button class="filter-btn" :class="{ active: activePopup === 'stars' }" @click="toggleStarPopup">
            <span class="material-symbols-outlined">star</span>
            Reviewed 1–5 Stars
            <span class="material-symbols-outlined small-icon">
              expand_more
            </span>
          </button>

          <!-- Popup Menu -->
          <div v-if="activePopup === 'stars'" class="star-popup-menu">

            <label v-for="star in 5" :key="star" class="checkbox-row">
              <input type="checkbox" :value="star" v-model="activeStarFilters" />
              {{ star }} Star
            </label>

            <div class="menu-actions">
              <button @click="clearStars">Clear</button>
              <button class="primary-btn" @click="applyStarFilter">
                Apply
              </button>
            </div>

          </div>

        </div>
      </div>

      <div class="toolbar-right">

        <!-- <button class="ghost-btn">
          <span class="material-symbols-outlined">upload</span>

        </button> -->
        <button @click="expNow()" class="ghost-btn">
          <span class="material-symbols-outlined">download</span>

        </button>

        <!-- FILTERS BUTTON -->
        <!-- <div class="filter-wrapper">

          <button class="ghost-btn" @click="toggleDropdown('advanced')">
            <span class="material-symbols-outlined">tune</span>
            Filters
          </button>

          <div v-if="activeDropdown === 'advanced'" class="advanced-panel">

            <div class="panel-section">
              <label>Customer Status</label>
              <select v-model="filters.status">
                <option value="">All</option>
                <option>Active</option>
                <option>Inactive</option>
              </select>
            </div>

            <div class="panel-section">
              <label>Review Requests</label>
              <select v-model="filters.review">
                <option value="">Any</option>
                <option>Pending</option>
                <option>Completed</option>
              </select>
            </div>

            <div class="panel-section">
              <label>Date Range</label>
              <div class="date-row">
                <input type="date" v-model="filters.from" />
                <input type="date" v-model="filters.to" />
              </div>
            </div>

            <div class="panel-footer">
              <button @click="resetFilters">Reset</button>
              <button class="apply-btn" @click="applyFilters">Apply</button>
            </div>

          </div>

        </div> -->


        <!-- <button @click="add_camp()" class="primary-btn">
          <span class="material-symbols-outlined">person_add</span>
          New Customer
        </button> -->

      </div>

    </div>

    <!-- ===== METRICS STRIP ===== -->
    <div class="metrics-grid">

      <div v-for="metric in metrics" :key="metric.key" class="metric-card">
        <span>{{ metric.label }}</span>

        <strong :class="metric.class">
          {{ metric.value }}
        </strong>
      </div>

    </div>
    <!-- ===== TABLE ===== -->
    <div class="table-card">

      <table>
        <thead>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>Phone</th>
            <th  v-if="campaignType==='Review'">Rating</th>
            <th>Invite Status</th>
            <th>Ai Replay Status</th>
            <th class="right">Actions</th>
          </tr>
        </thead>

        <tbody>

          <tr v-for="customer in customers" :key="customer.user_id">

            <td>
              <div class="customer-cell">
                <!-- <div class="avatar">{{ customer.user_name.charAt(0).toUpperCase() }}</div> -->
                <div>
                  <div class="name">{{ customer.user_name }}</div>

                </div>
              </div>
            </td>

            <td>
              <div class="contact">
                <div>{{ customer.user_email }}</div>
                <div class="muted" v-if="customer.rw_dt!=null && customer.user_tags==='Review'">
                  {{ beautifyDate(customer.rw_dt.review_datetime) }}
                </div>
                <div class="muted" v-else-if="customer.rw_dt!=null && customer.user_tags==='Ref'">
                  {{ beautifyDate(customer.rw_dt.ref_datetime) }}
                </div>
              </div>
            </td>
            <td>
              <div class="contact">
                <div>{{ customer.user_mobile }}</div>
                <div class="tags" style="margin-top: .4rem;">
                  <span v-if=" customer.user_tags==='Review'">
                    {{ customer.camp_title }}
                  </span>
                  <span v-if=" customer.user_tags==='Ref'">
                    {{ customer.ref_camp_name }}
                  </span>
                </div>
              </div>
            </td>
            <td  v-if="campaignType==='Review'">
              <div class="stars" v-if="customer.rw_dt!=null">
                <span v-for="i in 5" :key="i" class="material-symbols-outlined"
                  :class="{ filled: i <= parseInt(customer.rw_dt.review_rating) }">
                  star
                </span>
              </div>
              <div class="stars" v-else>
                <span v-for="i in 5" :key="i" class="material-symbols-outlined">
                  star
                </span>
              </div>
            </td>
            <td>
              <span v-if="customer.rw_status!=null && customer.user_tags==='Review'">
                {{ customer.rw_status.camp_inv_status==="pending"?"Pending":"Completed" }}
              </span>
              <span v-if="customer.rw_status!=null && customer.user_tags==='Ref'">
                {{ customer.rw_status.ref_inv_status==="pending"?"Pending":"Completed" }}
              </span>
            </td>
            <td>
              <span
                v-if="customer.rw_status!=null &&  customer.rw_status.camp_inv_ai_replay!=null &&  customer.rw_status.camp_inv_ai_replay.length>0">
                {{ customer.rw_status.camp_inv_ai_replay }}
              </span>
            </td>



            <td class="right">

              <div class="action-wrapper">

                <button class="mini-btn" @click="toggleRowMenu(customer.user_id)">
                  •••
                </button>

                <div v-if="activeRowMenu === customer.user_id" class="row-menu">
                  <!-- <div @click="viewCustomer(customer)">View Profile</div> -->
                  <div @click="editCustomer(customer)">Edit</div>
                  <!-- <div @click="sendCampaign(customer)">Send Campaign</div> -->
                  <div class="danger" @click="deleteCustomer(customer)">Delete</div>
                </div>

              </div>

            </td>


          </tr>

        </tbody>
      </table>

      <!-- Pagination -->
      <div class="pagination">

        <span>
          Showing {{ startItem }} – {{ endItem }} of {{ totalCustomers }} customers
        </span>

        <div class="pages">

          <!-- PREV -->
          <button @click="changePage(page - 1)" :disabled="page === 0">
            <span class="material-symbols-outlined">chevron_left</span>
          </button>

          <!-- PAGE NUMBERS -->
          <button v-for="page1 in totalPages" :key="page1" @click="changePage(page1 - 1)"
            :class="{ active: page === (page1 - 1) }">
            {{ page }}
          </button>

          <!-- NEXT -->
          <button @click="changePage(page + 1)" :disabled="page >= totalPages - 1">
            <span class="material-symbols-outlined">chevron_right</span>
          </button>

        </div>
      </div>

    </div>
    <!-- <NewCustomer v-if="showWizard" /> -->
    <NewCustomer v-if="showWizard" :editData="editCustomerData" @close="closeModal" />

    <!-- DELETE CONFIRMATION POPUP -->
    <div v-if="deletePopup.show" class="popup-overlay">
      <div class="delete-popup-card">

        <span class="material-symbols-outlined warning-icon">
          delete
        </span>

        <h3>Delete Customer</h3>

        <p>
          Are you sure you want to delete
          <strong>{{ deletePopup.customer?.user_name }}</strong>?
        </p>

        <div class="popup-actions">
          <button @click="deletePopup.show = false">
            Cancel
          </button>

          <button class="danger-btn" @click="confirmDelete">
            Yes, Delete
          </button>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import NewCustomer from '../comps/NewCustomer.vue'
  import { getCustomerList, getCustomerKpiStats, deleteCusNow } from '../apis/customerapis'
  import {
    getCampaignList,
  } from "../apis/campaignapis";

  import {
    apiBaseUrl,
  } from "../apis/appconst";
  import { useToast } from 'vue-toastification'
  import { useRoute } from 'vue-router';

  export default {
    name: 'CustomersListScreen',

    components: { NewCustomer },

    data() {
      return {
        activePopup: null,
        activeStarFilters: [],
        campaignType: "Review",   // "Review" or "Ref"
        selectedCampaign: "",
        ldata: null,
        camps: [],
        deletePopup: {
          show: false,
          customer: null
        },
        toast: useToast(),
        search_key: "",
        searchTimer: null,

        activeDropdown: null,
        activeRowMenu: null,
        showWizard: false,

        loading: false,

        /* ✅ PAGINATION */
        page: 0,
        totalCustomers: 0,
        pageSize: 10,
        editCustomerData: null,    // ⭐ MUST MATCH BACKEND LIMIT


        /* ✅ FILTERS */
        filters: {
          tag: "",
          sentiment: "",
          activity: "",

          status: '',
          review: '',
          from: null,
          to: null
        },

        /* ✅ KPI DATA */
        kpis: {
          total_customers: "0",
          active_customers: "0",
          awaiting_review_req: "0",
          positive_sentiments: "0"
        },

        availableTags: ['VIP', 'Loyal', 'Referral', 'Review Pending'],
        sentiments: ['Positive', 'Neutral', 'Negative'],
        activities: ['Active Campaign', 'No Campaign', 'Paused'],

        customers: []
      }
    },
    watch: {

      search_key(newVal) {
        console.log("sdasdas", newVal);
        clearTimeout(this.searchTimer);

        this.searchTimer = setTimeout(() => {

          this.page = "0";          // ✅ Reset pagination on search
          this.loadCustomers();

        }, 400);                    // ✅ Debounce delay (perfect UX)

      }

    },
    computed: {

      totalPages() {
        return Math.ceil(this.totalCustomers / this.pageSize);
      },

      startItem() {
        return this.totalCustomers === 0
          ? 0
          : (this.page * this.pageSize) + 1;
      },

      endItem() {
        const end = (this.page + 1) * this.pageSize;
        return end > this.totalCustomers ? this.totalCustomers : end;
      },
      mappedCustomers() {
        return this.customers.map(c => ({
          id: c.user_id,
          name: c.user_name,
          initials: this.getInitials(c.user_name),
          email: c.user_email,
          phone: c.user_mobile,
          location: c.user_activity,
          tags: c.user_tags ? c.user_tags.split(",") : [],
          sentiment: c.user_sentiment || "Neutral",
          activity: c.user_status || "Active",
          lastInteraction: c.user_datetime
        }))
      }
      ,
      metrics() {
        return [
          {
            key: "total",
            label: "Total Customers",
            value: this.kpis.total_customers || "0"
          },
          {
            key: "active",
            label: "Active Customers",
            value: this.kpis.active_customers || "0"
          },
          {
            key: "awaiting",
            label: "Awaiting Review Requests",
            value: this.kpis.awaiting_review_req || "0"
          },
          {
            key: "positive",
            label: "Positive Sentiment",
            value: this.kpis.positive_sentiments || "0",
            class: "positive"
          }
        ]
      }


    },

    mounted() {
      document.addEventListener("click", this.handleOutsideClick);
      const ldataRaw = sessionStorage.getItem('ldata');
      this.ldata = ldataRaw ? JSON.parse(ldataRaw) : null;
      const route = useRoute();
      if (route.query.rtype) {
        const rtype = route.query.rtype;
        if (rtype.localeCompare("new") == 0) {
          this.editCustomerData = null;
          this.showWizard = true;
        }
      }

      this.loadCamps();
      this.loadCustomers();
      this.loadKpis();
    },
    beforeUnmount() {
      document.removeEventListener("click", this.handleOutsideClick);
    },
    methods: {
      handleOutsideClick(e) {
        if (!this.$el.contains(e.target)) {
          this.activePopup = null;
        }
      },
      toggleStarPopup() {
        this.activePopup =
          this.activePopup === "stars" ? null : "stars";
      },

      clearStars() {
        this.activeStarFilters = [];
        this.loadCustomers();
        this.activePopup = null;
      },

      async applyStarFilter() {
        this.activePopup = null;
        this.page = 0;
        await this.loadCustomers();
      },
      toggleStarDropdown() {
        this.activePopup =
          this.activePopup === "stars" ? null : "stars";
      },
      expNow() {

        const bussId =
          JSON.parse(sessionStorage.getItem("myBuss"))?.buss_id || "";

        const params = new URLSearchParams({
          user_id: this.ldata.user_id,
          user_tags: this.campaignType,          // "Review" or "Ref"
          user_activity: this.selectedCampaign, // selected campaign ID
          filters: JSON.stringify({
            ...this.filters,
            campaign: this.selectedCampaign
          }),
          search_key: this.search_key,
          buss_id: bussId
        });

        const url = apiBaseUrl + "exp/customer/export?" + params.toString();

        window.open(
          url,
          "_blank",
          "noopener,noreferrer"
        );
      },
      deleteCustomer(customer) {
        this.deletePopup.customer = customer;
        this.deletePopup.show = true;
        this.activeRowMenu = null;
      },
      async confirmDelete() {

        if (!this.deletePopup.customer) return;

        try {

          const res = await deleteCusNow(
            this.deletePopup.customer.user_id
          );

          if (res.status) {
            this.loadCustomers();
            this.loadKpis();
            this.toast.success("Customer deleted");
          } else {
            this.toast.error(res.success || "Delete failed");
          }

        } catch (err) {
          console.error(err);
          this.toast.error("Delete failed");
        }

        this.deletePopup.show = false;
        this.deletePopup.customer = null;
      },
      beautifyDate(datetime) {
        if (!datetime) return "";

        const date = new Date(datetime.replace(" ", "T"));

        return date.toLocaleString("en-IN", {
          day: "numeric",
          month: "short",
          year: "numeric",
          hour: "numeric",
          minute: "2-digit"
        });
      },
      closeModal() {
        this.editCustomerData = null;
        this.showWizard = false;
        this.loadCustomers();
        this.loadKpis();
      },
      editCustomer(customer) {
        this.editCustomerData = customer;
        this.activeRowMenu = null;
        this.showWizard = true;
      },
      /* ================= LOADERS ================= */
      async changePage(page) {

        if (page < 0 || page >= this.totalPages) return;

        this.page = page;

        await this.loadCustomers();
      },
      async loadCamps() {
        const res = await getCampaignList(
          this.ldata.user_id,
          "",
          "",             // platform (future ready)
          "",
          "",
          "0"
        );

        if (!res.status) return;

        this.camps = res.campaigns;
      },
      async loadCustomers() {

        this.loading = true;

        try {

          const res = await getCustomerList(
            this.campaignType,
            this.selectedCampaign,                  // ✅ user_tags
            JSON.stringify({
              ...this.filters,
              campaign: this.selectedCampaign     // include campaign filter
            }),
            this.search_key,
            this.page,
            this.ldata.user_id,
            this.activeStarFilters
          );

          if (res.status) {
            this.customers = res.customers || [];
          }

        } catch (err) {
          console.error(err);
        }

        this.loading = false;
      },

      async loadKpis() {

        try {

          const res = await getCustomerKpiStats(this.ldata.user_id)

          if (res.status) {
            this.kpis = res.data
            this.totalCustomers = parseInt(this.kpis.total_customers + "");
          }

        } catch (err) {
          console.error(err)
        }
      },

      /* ================= HELPERS ================= */

      getInitials(name) {
        if (!name) return "NA"
        return name
          .split(" ")
          .map(w => w[0])
          .join("")
          .substring(0, 2)
          .toUpperCase()
      },

      /* ================= UI ================= */

      add_camp() {
        this.editCustomerData = null;
        this.showWizard = true
      },

      toggleDropdown(type) {
        this.activeDropdown =
          this.activeDropdown === type ? null : type
      },

      toggleRowMenu(id) {
        this.activeRowMenu =
          this.activeRowMenu === id ? null : id
      },

      selectTag(tag) {
        this.filters.tag = tag
        this.loadCustomers()
        this.activeDropdown = null
      },

      selectSentiment(sentiment) {
        this.filters.sentiment = sentiment
        this.loadCustomers()
        this.activeDropdown = null
      },

      selectActivity(activity) {
        this.filters.activity = activity
        this.loadCustomers()
        this.activeDropdown = null
      },

      resetFilters() {

        this.filters = {
          tag: "",
          sentiment: "",
          activity: "",
          status: '',
          review: '',
          from: null,
          to: null
        }

        this.loadCustomers()
      },

      applyFilters() {
        this.loadCustomers()
        this.activeDropdown = null
      },

      /* ================= PAGINATION ================= */

      nextPage() {
        this.page++
        this.loadCustomers()
      },

      prevPage() {
        if (this.page === 0) return
        this.page--
        this.loadCustomers()
      }

    }
  }
</script>
<style scoped>
  .customers-page {
    padding: 28px;
    display: flex;
    flex-direction: column;
    gap: 18px;
  }

  /* TITLE */
  .page-title h1 {
    font-size: 28px;
    font-weight: 800;
  }

  .page-title p {
    font-size: 14px;
    color: #64748b;
    margin-top: 4px;
  }

  /* METRICS */
  .metrics-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    gap: 14px;
  }

  .metric-card {
    background: white;
    border-radius: 16px;
    padding: 18px;
    border: 1px solid #e2e8f0;
  }

  .metric-card span {
    font-size: 12px;
    color: #64748b;
  }

  .metric-card strong {
    font-size: 22px;
    margin-top: 6px;
    display: block;
  }

  .positive {
    color: #16a34a;
  }

  /* CUSTOMER */
  .customer-cell {
    display: flex;
    gap: 10px;
    align-items: center;
  }

  .avatar {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: #197fe6;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    font-weight: 700;
  }

  .name {
    font-weight: 600;
  }

  .meta {
    font-size: 12px;
    color: #94a3b8;
  }

  /* TAGS */
  .tags {
    display: flex;
    gap: 6px;
    flex-wrap: wrap;
  }

  .tags span {
    background: #f1f5f9;
    padding: 4px 10px;
    border-radius: 20px;
    font-size: 11px;
  }

  /* SENTIMENT */
  .sentiment {
    padding: 5px 12px;
    border-radius: 20px;
    font-size: 11px;
    font-weight: 700;
  }

  .sentiment.positive {
    background: #dcfce7;
    color: #166534;
  }

  .sentiment.neutral {
    background: #f1f5f9;
    color: #475569;
  }

  .sentiment.negative {
    background: #fee2e2;
    color: #991b1b;
  }

  /* TABLE */
  .table-card {
    background: white;
    border-radius: 18px;
    border: 1px solid #e2e8f0;
    overflow-x: auto;
  }

  table {
    width: 100%;
    min-width: 1000px;
  }

  /* MOBILE */
  @media(max-width:768px) {
    .customers-page {
      padding: 16px;
    }

    .metrics-grid {
      grid-template-columns: 1fr;
    }
  }

  /* ================= PAGE ================= */

  .customers-page {
    padding: 28px;
    display: flex;
    flex-direction: column;
    gap: 18px;
    background: #f6f7f8;
    min-height: 100vh;
  }

  /* ================= TITLE ================= */

  .page-title h1 {
    font-size: 28px;
    font-weight: 800;
    color: #0f172a;
  }

  .page-title p {
    font-size: 14px;
    color: #64748b;
    margin-top: 4px;
  }

  /* ================= TOOLBAR ================= */

  .toolbar {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    flex-wrap: wrap;
  }

  .toolbar-left {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
    align-items: center;
  }

  .toolbar-right {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
  }

  /* ================= SEARCH ================= */

  .search-box {
    height: 40px;
    background: white;
    border-radius: 10px;
    padding: 0 12px;
    display: flex;
    align-items: center;
    gap: 6px;
    border: 1px solid #e2e8f0;
    min-width: 260px;
  }

  .search-box span {
    font-size: 18px;
    color: #94a3b8;
  }

  .search-box input {
    border: none;
    outline: none;
    font-size: 13px;
    width: 100%;
  }

  /* ================= FILTER BUTTON ================= */

  .filter-btn {
    height: 40px;
    padding: 0 14px;
    background: white;
    border-radius: 10px;
    border: 1px solid #e2e8f0;
    font-size: 13px;
    font-weight: 600;
    color: #475569;
    display: flex;
    align-items: center;
    gap: 4px;
    cursor: pointer;
    transition: 0.2s;
  }

  .filter-btn:hover {
    background: #f8fafc;
  }

  /* ================= BUTTONS ================= */

  .primary-btn {
    height: 40px;
    padding: 0 16px;
    background: #197fe6;
    border-radius: 10px;
    color: white;
    font-size: 13px;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 6px;
    border: none;
    cursor: pointer;
    transition: 0.2s;
  }

  .primary-btn:hover {
    background: #166fd1;
  }

  .ghost-btn {
    height: 40px;
    padding: 0 14px;
    background: white;
    border-radius: 10px;
    border: 1px solid #e2e8f0;
    font-size: 13px;
    font-weight: 600;
    color: #475569;
    display: flex;
    align-items: center;
    gap: 6px;
    cursor: pointer;
    transition: 0.2s;
  }

  .ghost-btn:hover {
    background: #f8fafc;
  }

  /* ================= METRICS ================= */

  .metrics-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    gap: 14px;
  }

  .metric-card {
    background: white;
    border-radius: 16px;
    padding: 18px;
    border: 1px solid #e2e8f0;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03);
  }

  .metric-card span {
    font-size: 12px;
    color: #64748b;
  }

  .metric-card strong {
    font-size: 22px;
    margin-top: 6px;
    display: block;
    color: #0f172a;
  }

  .positive {
    color: #16a34a;
  }

  /* ================= TABLE CARD ================= */

  .table-card {
    background: white;
    border-radius: 18px;
    border: 1px solid #e2e8f0;
    overflow-x: auto;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.04);
  }

  /* ================= TABLE ================= */

  table {
    width: 100%;
    border-collapse: collapse;
    min-width: 1000px;
  }

  thead {
    background: #f8fafc;
  }

  th {
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 0.3px;
    font-weight: 700;
    color: #94a3b8;
    padding: 14px 18px;
    text-align: left;
  }

  td {
    padding: 16px 18px;
    border-top: 1px solid #f1f5f9;
    font-size: 13px;
    color: #0f172a;
  }

  tbody tr:hover {
    background: #f8fafc;
  }

  /* ================= CUSTOMER CELL ================= */

  .customer-cell {
    display: flex;
    gap: 10px;
    align-items: center;
  }

  .avatar {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: #197fe6;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    font-weight: 700;
  }

  .name {
    font-weight: 600;
  }

  .meta {
    font-size: 12px;
    color: #94a3b8;
  }

  /* ================= CONTACT ================= */

  .contact small {
    font-size: 11px;
    color: #94a3b8;
  }

  /* ================= TAGS ================= */

  .tags {
    display: flex;
    gap: 6px;
    flex-wrap: wrap;
  }

  .tags span {
    background: #f1f5f9;
    padding: 4px 10px;
    border-radius: 20px;
    font-size: 11px;
    font-weight: 600;
    color: #475569;
  }

  /* ================= SENTIMENT ================= */

  .sentiment {
    padding: 5px 12px;
    border-radius: 20px;
    font-size: 11px;
    font-weight: 700;
  }

  .sentiment.positive {
    background: #dcfce7;
    color: #166534;
  }

  .sentiment.neutral {
    background: #f1f5f9;
    color: #475569;
  }

  .sentiment.negative {
    background: #fee2e2;
    color: #991b1b;
  }

  /* ================= CAMPAIGN STATUS ================= */

  .campaign-status {
    font-size: 12px;
    font-weight: 600;
    color: #197fe6;
  }

  /* ================= MUTED TEXT ================= */

  .muted {
    font-size: 12px;
    color: #94a3b8;
  }

  /* ================= ACTION BUTTON ================= */

  .mini-btn {
    width: 32px;
    height: 32px;
    border-radius: 8px;
    border: 1px solid #e2e8f0;
    background: white;
    cursor: pointer;
    font-size: 16px;
    color: #64748b;
    transition: 0.2s;
  }

  .mini-btn:hover {
    background: #f1f5f9;
  }

  /* ================= ALIGNMENT ================= */

  .right {
    text-align: right;
  }

  /* ================= PAGINATION ================= */

  .pagination {
    padding: 16px 18px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;
    color: #64748b;
    border-top: 1px solid #f1f5f9;
  }

  .pages {
    display: flex;
    gap: 6px;
  }

  .pages button {
    width: 32px;
    height: 32px;
    border-radius: 8px;
    border: 1px solid #e2e8f0;
    background: white;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
  }

  .pages button.active {
    background: #197fe6;
    color: white;
    border-color: #197fe6;
  }

  .pages button:disabled {
    opacity: 0.4;
    cursor: default;
  }

  /* ================= MOBILE ================= */

  @media(max-width:768px) {

    .customers-page {
      padding: 16px;
    }

    .toolbar {
      flex-direction: column;
    }

    .toolbar-left,
    .toolbar-right {
      width: 100%;
    }

    .search-box {
      width: 100%;
      min-width: unset;
    }

    .filter-btn,
    .ghost-btn,
    .primary-btn {
      flex: 1;
      justify-content: center;
    }

    .pagination {
      flex-direction: column;
      gap: 10px;
    }
  }

  /* ================= DROPDOWN ================= */

  .filter-wrapper {
    position: relative;
  }

  .dropdown-panel {
    position: absolute;
    top: 46px;
    left: 0;
    background: white;
    border-radius: 12px;
    border: 1px solid #e2e8f0;
    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.08);
    min-width: 180px;
    z-index: 20;
    padding: 6px;
    animation: dropdownIn 0.18s ease;
  }

  .dropdown-panel div {
    padding: 8px 10px;
    border-radius: 8px;
    font-size: 13px;
    cursor: pointer;
    transition: 0.15s;
  }

  .dropdown-panel div:hover {
    background: #f1f5f9;
    color: #197fe6;
  }

  @keyframes dropdownIn {
    from {
      opacity: 0;
      transform: translateY(-4px);
    }

    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  /* ================= ADVANCED FILTER PANEL ================= */

  .advanced-panel {
    position: absolute;
    top: 46px;
    right: 0;
    width: 260px;
    background: white;
    border-radius: 14px;
    border: 1px solid #e2e8f0;
    box-shadow: 0 20px 45px rgba(0, 0, 0, 0.12);
    padding: 14px;
    z-index: 50;
    animation: dropdownIn 0.18s ease;
  }

  .panel-section {
    margin-bottom: 12px;
  }

  .panel-section label {
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    color: #94a3b8;
    display: block;
    margin-bottom: 6px;
  }

  .panel-section select,
  .panel-section input {
    width: 100%;
    height: 36px;
    border-radius: 8px;
    border: 1px solid #e2e8f0;
    padding: 0 10px;
    font-size: 12px;
    outline: none;
  }

  .date-row {
    display: flex;
    gap: 6px;
  }

  .panel-footer {
    display: flex;
    justify-content: space-between;
    margin-top: 8px;
  }

  .panel-footer button {
    font-size: 12px;
    font-weight: 600;
    padding: 6px 10px;
    border-radius: 8px;
    border: 1px solid #e2e8f0;
    background: white;
    cursor: pointer;
  }

  .apply-btn {
    background: #197fe6 !important;
    color: white !important;
    border-color: #197fe6 !important;
  }

  /* ================= ACTION MENU ================= */

  .action-wrapper {
    position: relative;
    display: inline-block;
  }

  .row-menu {
    position: absolute;
    right: 0;
    top: 38px;
    text-align: left;
    background: white;
    border-radius: 10px;
    border: 1px solid #e2e8f0;
    box-shadow: 0 18px 40px rgba(0, 0, 0, 0.12);
    min-width: 160px;
    z-index: 50;
    padding: 6px;
    animation: dropdownIn 0.15s ease;
  }

  .row-menu div {
    padding: 8px 10px;
    border-radius: 8px;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    transition: 0.15s;
  }

  .row-menu div:hover {
    background: #f1f5f9;
    color: #197fe6;
  }

  .row-menu .danger {
    color: #dc2626;
  }

  .row-menu .danger:hover {
    background: #fee2e2;
  }

  .popup-overlay {
    position: fixed;
    inset: 0;
    /* FULL SCREEN */
    background: rgba(15, 23, 42, 0.45);
    /* Dark blur feel */
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    /* ABOVE EVERYTHING */
    backdrop-filter: blur(4px);
    /* Premium glass effect */
  }

  .delete-popup-card {
    width: 100%;
    max-width: 380px;
    background: white;
    border-radius: 18px;
    padding: 26px;
    text-align: center;
    box-shadow: 0 30px 60px rgba(0, 0, 0, 0.12);
    animation: popupEnter 0.25s ease;
  }

  .warning-icon {
    font-size: 42px;
    color: #dc2626;
    margin-bottom: 10px;
  }

  .popup-actions {
    margin-top: 18px;
    display: flex;
    gap: 10px;
  }

  .popup-actions button {
    flex: 1;
    height: 42px;
    border-radius: 10px;
    border: 1px solid #e2e8f0;
    background: white;
    font-weight: 600;
    cursor: pointer;
  }

  .danger-btn {
    background: #dc2626 !important;
    color: white !important;
    border-color: #dc2626 !important;
  }

  .danger-btn:hover {
    background: #b91c1c !important;
  }

  /* Campaign Type Select */

  .type-select select {
    height: 40px;
    border-radius: 10px;
    border: 1px solid #e2e8f0;
    padding: 0 12px;
    font-size: 13px;
    background: white;
    color: #475569;
    min-width: 180px;
    outline: none;
    cursor: pointer;
    transition: 0.2s;
  }

  .type-select select:hover {
    background: #f8fafc;
  }

  .type-select select:focus {
    border-color: #197fe6;
  }

  /* ===== STAR POPUP MENU ===== */

  .filter-wrapper {
    position: relative;
  }

  .star-popup-menu {
    position: absolute;
    top: 46px;
    left: 0;
    width: 200px;
    background: white;
    border-radius: 14px;
    border: 1px solid #e2e8f0;
    box-shadow: 0 18px 40px rgba(0, 0, 0, 0.12);
    padding: 10px;
    z-index: 100;
    animation: dropdownIn 0.18s ease;
  }

  .checkbox-row {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 10px;
    font-size: 13px;
    border-radius: 8px;
    cursor: pointer;
    transition: 0.15s;
  }

  .checkbox-row:hover {
    background: #f1f5f9;
  }

  .checkbox-row input {
    accent-color: #197fe6;
  }

  .menu-actions {
    display: flex;
    justify-content: space-between;
    gap: 6px;
    margin-top: 10px;
  }

  .menu-actions button {
    flex: 1;
    height: 34px;
    border-radius: 8px;
    border: 1px solid #e2e8f0;
    background: white;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
  }

  .menu-actions button:hover {
    background: #f1f5f9;
  }

  .small {
    height: 34px;
    font-size: 12px;
  }

  /* ===== APPLY BUTTON FIX ===== */

  .star-popup-menu .primary-btn {
    height: 34px;
    border-radius: 8px;
    border: none;
    background: #197fe6;
    color: white;
    font-size: 12px;
    font-weight: 600;
    transition: 0.2s;
  }

  .star-popup-menu .primary-btn:hover {
    background: #166fd1;
  }

  /* Clear button style */
  .star-popup-menu .menu-actions button:first-child {
    background: white;
    border: 1px solid #e2e8f0;
    color: #475569;
  }

  .star-popup-menu .menu-actions button:first-child:hover {
    background: #f1f5f9;
  }

  .stars {
    display: flex;
    gap: 2px;
  }

  .stars .filled {
    color: #f59e0b;
  }

  .stars .material-symbols-outlined {
    font-size: 18px;
    color: #e2e8f0;
  }

  .stars .filled {
    color: #f59e0b;
  }
</style>